import React from 'react';
import {useNavigate} from "react-router-dom";
import {FormattedMessage} from "react-intl";
import Button from "@mui/material/Button";

import './SignUpButton.style.scss';

export const SignUpButton = ({visible}) => {
    const navigate = useNavigate();

    return <Button variant="outlined"
                   className="SignUpButton"
                   style={!visible ? {opacity: 0, pointerEvents: 'none'} : {}}
                   onClick={() => navigate("/register")}>
            <FormattedMessage id={'popUp.login.signUp'}/>
    </Button>
}

export default SignUpButton;